import { useSelector } from "react-redux";
import GuidedSearchBoard from "../../../../../features/browse-search/components/GuidedSearchBoard";
import { hasRenderableGuidedSearch } from "../../../../../features/browse-search/components/GuidedSearch/normaliseVisualRefinements";
import { getGuidedSearchData } from "../../../../../state/modules/search";
import BaseCategoryPage from "../../../CategoryPage";

export const CategoryPage = (props) => {
  const guidedSearchData = useSelector(getGuidedSearchData);

  return (
    <BaseCategoryPage
      {...props}
      hideHeaderDescription={hasRenderableGuidedSearch(guidedSearchData)}
      topContent={<GuidedSearchBoard withCategoryDescription />}
    />
  );
};

export default CategoryPage;
